import { getFirestore, collection, query, getDocs, doc, addDoc, getDoc, setDoc, updateDoc, runTransaction, where, serverTimestamp, documentId, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { accountModel } from '../models/accountModel';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { userConverter, userModel } from '../models/userModel';
import { result } from '../utils/result';
import { getAllInviteByIdUser } from './inviteController';
import { saveOperador } from './equipeController';
import { getContaController } from './contaController';
import { apiGate, apiGate2 } from '../services/api_gate';
import { rules } from '../constants/rules';
import { plans } from '../constants/plans';
import { getPerfilByLicence } from '../utils/getPerfilByLicence';
import { planHasCRM } from '../constants/perfil';
import { getOperador, setOperador } from './crm/operadorController';
import { operadorStatus } from '../constants/crm';
import { listGimovPlans } from './plansController';
import { use } from 'react';
// import jwt from 'jsonwebtoken';

// import { setTokenMsg } from './messageriaController';


export function listenToCredito(user, callback) {
  try {
    var unsub = onSnapshot(doc(db, "usuarios", user.conta), (doc) => {
      if (!doc.exists) {
        callback({ success: false, message: 'Usuário não encontrado' });
      } else {
        const userData = doc.data();
        user.credito = userData.credito;
        callback({ success: true, credito: userData.credito });
      }
    },
      (error) => {
        callback({ success: false, message: error.message });
      }
    );
    return unsub;
  } catch (error) {
    callback({ success: false, message: error.message });
  }
}

// Função para parar de escutar as mudanças de credito em tempo real
export function stopListeningToCredito(unsubscribe) {
  if (typeof unsubscribe === 'function') {
    unsubscribe();
  }
}



// export async function setTokenMsg(_conta, _id) {
//   if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em setTokenMsg', _conta, _id) }
//   try {
//     const token = await generateToken()
//     await setDoc(doc(db, 'contas/' + _conta + '/tokenmsg/', _id), { token: token, date: new Date() })
//     result.sucess = true
//     result.msg = 'Token gerado com sucesso...'
//     result.data = token
//   }
//   catch (e) {
//     result.sucess = false
//     result.msg = 'Falha na geração do token...'
//     result.data = null
//     if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em setTokenMsg', e) }
//   }
//   finally {
//     if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu de setTokenMsg', result) }
//     return result
//   }
// }


export async function gravarUser(user) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em setUser', user) }
  if (user?.id === null) {
    result.sucess = false
    result.data = user
    result.msg = 'Usuario sem id...'
    return result
  }
  try {
    const userDocRef = doc(db, 'usuarios', user.id)

    await setDoc(userDocRef, user, { merge: true })
    result.sucess = true
    result.data = user
    result.msg = 'Registro gravado com sucesso.'
  }
  catch (e) {
    result.sucess = false
    result.data = e
    result.msg = 'Falha na gravação do registro.'
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em setUser', e) }
    return result
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu de setUser', result) }
    return result
  }

}

export async function setUserControl(usuario) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em setUserControl', usuario) }
  if (usuario?.id === null) return null;
  try {
    const userDocRef = doc(db, 'usuarios', usuario.id)
    await setDoc(userDocRef, usuario)
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em setUserControl', usuario, e) }
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu de setUserControl', usuario) }
    return usuario.id
  }
}


export const getUserControl = async (id) => {
  let user = new userModel();
  const docSnap = await getDoc(doc(db, 'usuarios', id))
  const data = docSnap.exists() ? docSnap.data() : null
  if (data === null || data === undefined) return null
  user.setData(data, id)
  return user
}


export const getAllUserContas = async (_contas) => {
  try {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou getAllUserContas :', _contas)
    let data = []
    const q = query(collection(db, "contas"),
      where(documentId(), "in", _contas),
    );
    const queryData = await getDocs(q);
    queryData.forEach((doc) => {
      let cta = doc.data()
      cta.id = doc.id
      data.push(cta)
    });
    result.sucess = true
    result.msg = 'Operação realizada com sucesso...'
    result.data = data
  }
  catch (e) {
    result.sucess = false
    result.msg = 'Falha na operação ...'
    result.data = null
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em getAllUserContas:', result, e)
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saiu de getAllUserContas:', result)
    return result
  }

}

export const getAllUserControl = async () => {
  const user = new userModel();
  let list = []
  const querySnapshot = await getDocs(collection(db, "usuarios"));
  querySnapshot.forEach((doc) => {
    user.setData(doc.data(), doc.id)
    list.push(user);
  });
  return list
}


export async function getUsuarioByEmail(_email) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em getOperadorByEmail:', _email)
  let operadores = [];
  try {
    const q = query(collection(db, "usuarios"),
      where("email", "==", _email.toLowerCase()),
      where("ativo", "==", true)
    );
    const queryData = await getDocs(q);
    queryData.forEach((doc) => {
      operadores.push(doc.data())
    });
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('getOperadorByEmail:', operadores)
    return operadores
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Falha em getOperadorByEmail', e)
  }
}

async function getOperadorByUser(_user) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em getOperadorByUser', _user) }
  let list = []
  try {
    const q = query(collection(db, 'contas/' + _user.conta[0] + '/operadores'),
      where('id', '==', _user.id),
      where('ativo', '==', true)
    )
    const queryData = await getDocs(q)
    queryData.forEach((doc) => {
      list.push(doc.data())
    })
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu do getOperdorByUser', list, q) }
    return list
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em getOperdorByUser', e) }
  }
}
// Verificar duplicação getUsuarioByEmail
export async function getUserByEmail(_email) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em getUserByEmail', _email) }
  let list = []
  try {
    const q = query(collection(db, 'usuarios').withConverter(userConverter),
      where('email', '==', _email),
      where('ativo', '==', true)
    )
    const queryData = await getDocs(q)
    queryData.forEach((doc) => {
      list.push(doc.data())
    })
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu do getUserByEmail', list) }
    return list
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em getUserByEmail', e) }
    return []
  }
}

// export async function generateToken(payload, opcoes = { expiresIn: '1h' }) {
//     // 'payload' é o objeto que você deseja incluir no token (ex: ID do usuário, nome, permissões).
//     // 'opcoes' são opções adicionais para o token, como tempo de expiração.
//     // 'chaveSecreta' é a chave usada para assinar o token. Você deve mantê-la em segredo.
//     try {
//         // O 'payload' é um objeto JavaScript contendo as informações que você deseja incluir no token
//         // (por exemplo, ID do usuário, nome de usuário, permissões).

//         // As 'opcoes' são um objeto opcional que permite configurar o token, como:
//         // - 'expiresIn': Define o tempo de expiração do token (ex: '1h', '30m', '7d').
//         // - 'algorithm': Especifica o algoritmo de assinatura (padrão é HS256).
//         // Consulte a documentação do jsonwebtoken para mais opções.

//         const token = jwt.sign(payload, process.env.REACT_APP_JWT_SECRET, opcoes);
//         return token;
//     } catch (error) {
//         console.error('Erro ao criar o token JWT:', error);
//         return null;
//     }
// }

export function generateTokenTmp() {
  // console.log('Origem Temporária', window.location)
  const originData = { origin: window.location.origin, time: new Date().getTime() };
  const base64Origin = btoa(JSON.stringify(originData));
  return base64Origin;
}

// export async function getToken() {
//   try {
//     const token = await (await apiGate2.get('/getToken')).data.token
//     if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Token:', token) }
//     return token
//   }
//   catch (e) {
//     if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em getToken', e) }
//     return null
//   }
// }

// Validar Login Integrado
async function getLicencaByEmail(email, userId) {
  try {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou do getLicencaByEmail', email, userId) }
    const encodedEmail = encodeURIComponent((email || '').toLowerCase())
    const url = '/clients/licenca/' + encodedEmail
    const params = {}
    if (userId) params.userId = userId
    const api = await apiGate2.get(url, { params })
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('api', api, 'url', url, 'params', params)
    if (api.status === 200) {
      result.code = 0
      result.sucess = true
      result.msg = 'Usuário com assinatura ativa.'
      result.data = api.data
      // return result
    }
    else {
      result.code = 0
      result.sucess = false
      result.msg = 'Usuário sem assinatura ativa.'
      result.data = null
      // return result
    }
  }
  catch (e) {
    // console.log('Erro em getLicencaByEmail', e)
    result.code = 5
    result.sucess = false
    result.msg = e.message
    result.msg2 = "Serviço de autenticação de assinaturas indisponível no momento, tente novamente mais tarde..."
    result.data = null
    // return result
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu do getLicencaByEmail', result) }
    return result
  }
}

let userRules = rules.ruleAdm.title
let userPermissions = rules.ruleAdm.permissions
let userPlan = null

// Valida a situação do plano do usuário
async function validateUserPlan(_user) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em validateUserPlan', _user)
  let dtcreated = _user.createdat.toDate()
  const rst = await getLicencaByEmail(_user.email, _user.id)
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Licença', rst)
  if (rst.sucess) {
    const licenca = rst.data
    dtcreated = licenca.create_at
    if (licenca.status === rules.customerStatus.ATV) {
      const userPerfil = getPerfilByLicence(licenca)
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Perfil:', userPerfil)

      //***************************************************************************************** */  

      // const plansGimov = await listGimovPlans()
      // if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('plansGimov:', plansGimov) }

      //***************************************************************************************** */
      if (userPerfil) {
        userRules = userPerfil.userRules
        userPermissions = userPerfil.userPermissions
        userPlan = userPerfil.userPlan
      }
      else {
        userRules = [rules.ruleConsulta.title]
        userPermissions = rules.ruleConsulta.permissions
        userPlan = plans.planUser
      }
      // Grava token de autenticação
      localStorage.setItem('token', licenca.token);
      localStorage.setItem('refreshToken', licenca.refreshToken);
      return {
        code: 0,
        sucess: true,
        msg2: 'Usuário com assinatura ativa...',
        data: { rules: userRules, permissions: userPermissions, plan: userPlan, licenca: licenca, token: licenca.token}
      }
    } else {
      return {
        code: 5,
        sucess: false,
        msg2: 'Usuário com assinatura vencida...',
        data: null
      }
    }
  }
  else {
    return rst
  }
}

function dateDiffInDays(a, b) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function validateDtCreationUser(_date) {
  let dt1 = new Date(_date)
  let dt2 = new Date(Date.now())
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Datas:', dt1, dt2, _date)
  const diff = dateDiffInDays(dt1, dt2)
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('dias:', diff)

  if (diff <= 3) {
    result.code = 0
    result.sucess = true
    result.msg = "Período de degustação...Você será redirecionado em breve..."
    result.data = { userRules, userPermissions, licenca: { subscription: { hascrm: false }, licenca: 'BROKER' } }
  } else if (diff > 3 && diff <= 8) {
    result.code = 1
    result.sucess = true
    result.msg = "Período de degustação...Você será redirecionado em breve..."
    result.data = { userRules, userPermissions, licenca: { subscription: { hascrm: false }, licenca: 'BROKER' } }
  } else if (diff > 8 && diff <= 16) {
    result.code = 2
    result.sucess = true
    result.msg = "Período de degustação encerrando, se você gostou do aplicativo sugerimos que considere realizar sua assinatura. Você será redirecionado em breve..."
    result.data = { userRules, userPermissions, licenca: { subscription: { hascrm: false }, licenca: 'BROKER' } }
  } else if (diff > 16 && diff <= 30) {
    result.code = 3
    result.sucess = true
    result.msg = "Período de degustação encerrado. Se você gostou do aplicativo incentivamos que realize sua assinatura. Você será redirecionado em breve..."
    result.data = { userRules, userPermissions, licenca: { subscription: { hascrm: false }, licenca: 'BROKER' } }
  } else if (diff > 30) {
    result.code = 4
    result.sucess = false
    result.msg = "Período de degustação encerrado. Se você gostou do aplicativo considere realizar sua assinatura."
    result.data = null
  }
  return result
}

function getValidouEmail(user) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou no getValidouEmail', user, user.emailVerified) }
  if (!user.emailVerified) {
    result.code = 6
    result.sucess = false
    result.msg = 'Valide seu email para acessar o sistema.'
    result.data = null
  }
  return result
}

async function getCRM(_user) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em getCRM', _user) }
  try {
    const query = {
      where: {
        idconta: _user.conta[0],
        idoperador: _user.id,
        status: operadorStatus.Disponivel
      }
    }
    const apiRst = await getOperador(query)
    if (apiRst.status === 200) {
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saiu de getOperador CRM:', apiRst.data) }
      if (apiRst.data.length > 0) {
        return true
      }
      else {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Operador CRM não localizado') }
        const _operador = {
          idconta: _user.conta[0],
          idoperador: _user.id,
          nome: _user.nome,
          telefone: _user.telefone,
          status: operadorStatus.Disponivel
        }
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Cadastrando Operador no CRM', _operador)
        const apiRst = await setOperador(_operador)
        if (apiRst.status === 200) {
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Operador CRM cadastrado:', apiRst.data)
          return true
        }
        else {
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Falha ao cadastrar Operador no CRM', apiRst)
          return false
        }
      }
    }
    else {
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em getCRM', apiRst) }
      return false
    }
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em getCRM', e) }
    return false
  }
}


// **********************************
// Principal função de autenticação *
// **********************************
export async function getUserAccount(userByCredential, _conta) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou no getUserAccount', userByCredential, userByCredential.email) }
  const userByEmail = await getUserByEmail(userByCredential.email) //
  if (userByEmail?.length > 0) { // Localizou Usuario
    userByEmail[0].accessToken = userByCredential.accessToken //<< Inclusão do token de acesso

    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuário selecionado:', userByEmail) }

    // Valida o Plano de Assinatura do Usuário
    const plan = await validateUserPlan(userByEmail[0])
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Plano:', plan, userByEmail) }
    if (plan.sucess) {
      userByEmail[0].plano = plan.data?.licenca ? plan.data.licenca.licenca : plans.planFree.title.toLocaleUpperCase()
      userByEmail[0].plan = plan.data.plan
      userByEmail[0].hasinvite = false
      userByEmail[0].hascrm = planHasCRM(userByEmail[0]) // Se o plano tem CRM ou não
      userByEmail[0].canwhatsmsg = plan.data.plan.sendwhatsmsg // Se o plano permite envio de mensagens via WhatsApp

      //Verifica se o usuario validou o email depois da validação de plano
      const emailValido = getValidouEmail(userByCredential)
      if (!emailValido.sucess) { return emailValido }

      //Verifica se o usuario recebeu convite
      let resInvite = await getAllInviteByIdUser(userByEmail[0].id)
      if (resInvite.sucess) {
        if (resInvite.data.length > 0) userByEmail[0].hasinvite = true
      }

      // Verifica a quantidade de contas vinculadas ao usuario
      let account = {}

      if (userByEmail[0].conta.length === 1) {  // Usuario com uma (1) conta vinculada

        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuario com 01 conta', userByEmail[0]) }
        // Grava token de mensagem
        // const tokenMsg = await saveTokenMsg(user[0].conta[0], user[0].id)
        // if (tokenMsg) { user[0].tokenmsg = tokenMsg }

        // Busca dados da Conta
        const conta = await getContaController(userByEmail[0].conta)

        // Usuario administrador de conta
        if (userByEmail[0].id === userByEmail[0].conta[0]) {

          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('USUARIO -> ADM', (userByEmail[0].plano === plans.planUser.title.toLocaleUpperCase() && userByEmail[0].rules[0] === rules.ruleAdm.title))
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log(plans.planUser.title.toLocaleUpperCase(), userByEmail[0].plano)
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log(rules.ruleAdm.title, userByEmail[0].rules[0])

          // Verifica se a conta/operador existe no CRM
          let _crm = false
          if (userByEmail[0].hascrm) {
            _crm = await getCRM(userByEmail[0])
          }

          // Tratamento especial para usuario com plano USER mas com perfil de ADMINISTRADOR
          if (userByEmail[0].plano === plans.planUser.title.toLocaleUpperCase() && userByEmail[0].rules[0] === rules.ruleAdm.id) {
            account = setAccount(
              userByEmail[0].id,
              userByEmail[0],
              plans.planUser.rule.permissions,
              [plans.planAdm.rule.title],
              userByEmail[0].conta[0],
              userByCredential.accessToken,
              userByCredential.emailVerified,
              userByEmail[0].hasinvite,
              conta.equipe,
              userByEmail[0].conta,
              userByEmail[0].credito,
              userByEmail[0].hascrm,
              userByEmail[0].telefone,
              userByEmail[0].tokenmsg,
              _crm,
              userByEmail[0].plan,
              userByEmail[0].canwhatsmsg
            )
          }
          else {
            if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuario Administrador', userByEmail[0]) }
            account = setAccount(
              userByEmail[0].id,
              userByEmail[0],
              plans.planAdm.rule.permissions,
              [plans.planAdm.rule.title],
              userByEmail[0].conta[0],
              userByCredential.accessToken,
              userByCredential.emailVerified,
              userByEmail[0].hasinvite,
              conta.equipe,
              userByEmail[0].conta,
              userByEmail[0].credito,
              userByEmail[0].hascrm,
              userByEmail[0].telefone,
              userByEmail[0].tokenmsg,
              _crm,
              userByEmail[0].plan,
              userByEmail[0].canwhatsmsg
            )
          }
          result.sucess = true
          result.data = account
          if (plan.code === 0) result.msg = 'Operação realizada com sucesso...'
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saida do getUserAccount:', result.data, 'Plan', plan) }

        }
        // Usuario operador de conta de terceiros
        else {
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuario Operador de Equipe - Conta de Terceiro', userByEmail[0]) }

          // Buscar em Operadores da Conta - contas/operadores
          const operador = await getOperadorByUser(userByEmail[0])

          // Verifica se a conta/operador existe no CRM
          let _crm = false
          if (userByEmail[0].hascrm) {
            _crm = await getCRM(userByEmail[0])
          }

          if (operador.length > 0) {
            account = setAccount(
              operador[0].id,
              userByEmail[0],
              operador[0].permissions,
              operador[0].rules,
              userByEmail[0].conta[0],
              userByCredential.accessToken,
              userByCredential.emailVerified,
              userByEmail[0].hasinvite,
              conta.equipe,
              userByEmail[0].conta,
              userByEmail[0].credito,
              userByEmail[0].hascrm,
              userByEmail[0].telefone,
              userByEmail[0].tokenmsg,
              _crm,
              userByEmail[0].plan,
              userByEmail[0].canwhatsmsg
            )

            result.sucess = true
            result.data = account
            result.msg = 'Operação realizada com sucesso...'
            if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saida do getUserAccount:', result.data) }
          }
          else {
            result.sucess = false
            result.data = account
            result.msg = 'Conta de trabalho inválida! Equipe de origem DESATIVADA. Caso necessário entre em contato com suporte@gate51.com.br. Obrigado!'
          }
        }
      }
      // -----------------------------------------------
      // *** Usuário com mais de uma conta vinculada ***
      // -----------------------------------------------

      if (userByEmail[0].conta.length > 1) {
        // Retorna para a interface para  definir a conta
        // e realizar novo login 
        if (_conta) {
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrando em Conta selecionada:', _conta, userByEmail[0])

          userByEmail[0].contas = userByEmail[0].conta
          userByEmail[0].conta = [_conta]

          // Busca dados da Conta
          const conta = await getContaController(userByEmail[0].conta)

          // Verifica se a conta/operador existe no CRM
          let _crm = false
          if (userByEmail[0].hascrm) {
            _crm = await getCRM(userByEmail[0])
          }

          // Grava token de mensagem
          // const tokenMsg = await saveTokenMsg(user[0].conta[0], user[0].id)
          // if (tokenMsg) { user[0].tokenmsg = tokenMsg }

          // Usuario Administrador da Conta
          if (userByEmail[0].id === userByEmail[0].conta[0]) {

            if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuario Administrador') }
            account = setAccount(
              userByEmail[0].id,
              userByEmail[0],
              plans.planAdm.rule.permissions,
              [plans.planAdm.rule.title],
              userByEmail[0].conta[0],
              userByCredential.accessToken,
              userByCredential.emailVerified,
              userByEmail[0].hasinvite,
              conta.equipe,
              userByEmail[0].contas,
              userByEmail[0].credito,
              userByEmail[0].hascrm,
              userByEmail[0].telefone,
              userByEmail[0].tokenmsg,
              _crm,
              userByEmail[0].plan,
              userByEmail[0].canwhatsmsg
            )

            result.sucess = true
            result.data = account
            result.msg = 'Operação realizada com sucesso...'
            if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saida do getUserAccount - Conta Selecionada:', result.data) }
          }
          // Usuario operador de conta de terceiros
          else {
            if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuario Operador de Equipe - Conta de Terceiro', userByEmail[0]) }
            // Buscar nos Operadores da Conta - contas/operadores
            const operador = await getOperadorByUser(userByEmail[0])

            if (operador.length > 0) {
              account = setAccount(
                operador[0].id,
                userByEmail[0],
                operador[0].permissions,
                operador[0].rules,
                userByEmail[0].conta[0],
                userByCredential.accessToken,
                userByCredential.emailVerified,
                userByEmail[0].hasinvite,
                conta.equipe,
                userByEmail[0].contas,
                userByEmail[0].credito,
                userByEmail[0].hascrm,
                userByEmail[0].telefone,
                userByEmail[0].tokenmsg,
                _crm,
                userByEmail[0].plan,
                userByEmail[0].canwhatsmsg
              )

              result.sucess = true
              result.data = account
              result.msg = 'Operação realizada com sucesso...'
              if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saida do getUserAccount - Conta Selecionada:', result.data) }
            }
            else {
              result.sucess = false
              result.data = null
              result.msg = 'Operador não cadastrado na equipe...'
            }
          }
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saindo Conta selecionada:', _conta, userByEmail)
        }
        else {
          // Trata Operador com mais de uma conta vinculada
          // Retorna para interface para seleção de conta
          result.sucess = false
          result.data = userByEmail[0].conta
          result.msg = 'cta' // Identificador de mais de uma conta vinculada
          if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuário com MAIS DE 1 CONTA vinculada.', userByEmail[0].conta) }
        }

      }

      //Usuario sem conta vinculada
      if (userByEmail[0].conta.length === 0 || userByEmail[0].conta === undefined) {
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Usuário SEM CONTA vinculada') }
        // Promove o usuário para Administrador
        await setUserToAdmn(userByEmail[0])
        // Cadastra Conta de Trabalho para o usuário
        await setContaTrabalho(userByEmail[0])
        account = setAccount(
          userByEmail[0].id,
          userByEmail[0],
          plans.planAdm.rule.permissions,
          [plans.planAdm.rule.title],
          userByEmail[0].id,
          userByCredential.accessToken,
          userByCredential.emailVerified,
          userByEmail[0].hasinvite,
          userByEmail[0].email,
          userByEmail[0].conta,
          userByEmail[0].credito,
          userByEmail[0].hascrm,
          userByEmail[0].telefone,
          userByEmail[0].tokenmsg,
          userByEmail[0].crm,
          userByEmail[0].plan,
          userByEmail[0].canwhatsmsg
        )

        result.sucess = true
        result.data = account
        result.msg = 'Operação realizada com sucesso...'
        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Saida do getUserAccount:', result.data) }

      }
      return result
    } else {
      return result
    }
  }
  else {
    result.sucess = false
    result.data = null
    result.msg = 'Usuário não encontrado...'
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Erro em getUserAccount', result) }
    return result
  }
}

function setAccount(id, usuario, permissions, rules, conta, token, emailVerified, hasinvite, equipe, contas, credito, hascrm, telefone, tokenmsg, crm, plan, canwhatsmsg) {
  const account = new accountModel(
    id,
    usuario.email,
    usuario.nome,
    permissions,
    rules,
    conta,
    usuario.plano,
    usuario.photoURL || '/assets/avatars/avatar1.jpg',
    token,
    emailVerified,
    hasinvite,
    equipe,
    contas,
    credito,
    hascrm,
    telefone,
    tokenmsg,
    crm,
    plan,
    canwhatsmsg
  )
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('setAccount:', account) }
  return account
}

async function setUserToAdmn(usuario) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em setUserToAdmn', usuario)
  try {
    await updateDoc(doc(db, 'usuarios', usuario.id), { conta: [usuario.id], rules: [plans.planAdm.title], permissions: plans.planAdm.rule.permissions })
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saiu de setUserToAdmn Ok!', usuario)
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em setUserToAdmn!', e)
  }
}

async function setContaTrabalho(usuario) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em setContaTrabalho', usuario)
  const tConta = {
    email: usuario.email,
    convite: null,
    conviteval: null,
    ativo: true,
    createdat: serverTimestamp(),
    equipe: usuario.email
  }
  try {
    await setDoc(doc(db, 'contas', usuario.id), tConta)
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Conta Traballho Ok!', tConta)
  }
  catch (e) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em setContaTrabalho!', e)
  }
}

export async function addNewUserControl(pws, usuario) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou no AddNewUserControl', usuario)
  // Cadastra Usuario no Firebase
  await createUserWithEmailAndPassword(auth, usuario.email, pws)
    .then((userCredential) => {
      usuario.msg += ' - Credential Ok!'
      usuario.token = userCredential.user.accessToken
      usuario.emailVerified = userCredential.user.emailVerified
      usuario.credito = 0
    })
    .catch((error) => {
      const errorCode = error.code;
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em createUserWithEmailAndPassword', error)
      usuario.id = null
      usuario.msg = errorCode
      throw error('Credential Fail')
    });

  // Cadastra Usuario no GIMOV
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Iniciou processo de cadastramento no GIMOV', usuario)
  try {
    const userColRef = collection(db, 'usuarios').withConverter(userConverter)
    await runTransaction(db, async (transaction) => {

      // Cria usuario
      const docRef = await addDoc(userColRef, usuario)
      usuario.id = docRef.id.toString();

      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Usuario cadastrado ID:', usuario.id)

      // Usuario Novo com conta de terceiros EQUIPE

      if (usuario.conta) {

        // Atualiza id do usuario Operador
        await updateDoc(doc(db, 'usuarios', usuario.id), { id: usuario.id, conta: [usuario.conta] })

        // Cadastra Operador em Conta de Terceiro - Equipe
        await saveOperador(usuario, usuario.conta)

        if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Conta Operador Consulta Ok')

      }
      else {// Usuario Administrador de Conta

        // Atualiza ID e a Conta do usuario Administrador
        await updateDoc(doc(db, 'usuarios', usuario.id), { id: usuario.id, conta: [usuario.id] })
        usuario.conta = usuario.id

        //Cria uma conta de trabalho para o usuario Administrador 
        setContaTrabalho(usuario)
      }
      usuario.msg += 'Cadastro Ok!'
    })
  } catch (e) {
    usuario.id = null
    usuario.msg += ' - Transaction failure!'
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro addNewUserControl', e)
  }
  finally {
    localStorage.setItem('token', JSON.stringify(usuario.token))
    return usuario
  }
}


//* Função para excluir um operador da Base Gimov postgres */

export async function deleteOperadorBD(_idconta, idOperador) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Entrou em deleteOperador', idOperador, _idconta)
  try {

    await apiGate.post('/crm/operador/delete', { idconta: _idconta, idoperador: idOperador, })
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Operador excluído com sucesso:', idOperador, _idconta)
    result.code = 0
    result.sucess = true
    result.msg = 'Operador excluído com sucesso...'
    result.data = null
  }
  catch (e) {
    result.sucess = false
    result.msg = 'Falha na operação...'
    result.data = { e }
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Erro em deleteOperador', e)
  }
  finally {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Saiu de deleteOperador', result)
    return result
  }
}
